import React from 'react';
import { motion } from 'framer-motion';
import { User, Sword, Coins, CaretRight } from '@phosphor-icons/react';
import { gameSystems, getTotalInBaseUnits, getSymbol } from '../data/gameSystems';
import { useTranslation } from '../hooks/useTranslation';

export const CharacterCard = ({ character, onClick, onOpenWallet }) => {
  const { t, lang } = useTranslation();
  const system = gameSystems[character.systemId];
  const totalBase = getTotalInBaseUnits(character.wallet, character.systemId);
  const defaultCurrency = system.currencies.find(c => c.id === system.defaultCurrency);
  const totalValue = totalBase / defaultCurrency.valueInBase;
  
  return (
    <motion.div
      data-testid={`character-card-${character.id}`}
      onClick={() => onOpenWallet(character.id)}
      className="relative p-4 rounded-2xl bg-[var(--surface)] active:bg-[var(--surface-hover)] cursor-pointer transition-colors"
      whileTap={{ scale: 0.98 }}
      initial={{ opacity: 0, y: 10 }}
      animate={{ opacity: 1, y: 0 }}
    >
      <div className="flex items-center gap-4">
        {/* Avatar */}
        <div className="w-12 h-12 rounded-xl bg-[var(--primary)]/10 flex items-center justify-center flex-shrink-0">
          <User size={24} weight="fill" className="text-[var(--primary)]" />
        </div>
        
        {/* Info */}
        <div className="flex-1 min-w-0">
          <h3 className="text-base font-semibold text-[var(--text)] truncate mb-1">
            {character.name}
          </h3>
          <div className="flex items-center gap-3 text-sm text-[var(--text-muted)]">
            <span className="flex items-center gap-1">
              <Sword size={14} weight="fill" />
              {system.name}
            </span>
            <span className="flex items-center gap-1 text-[var(--gold)]">
              <Coins size={14} weight="fill" />
              {totalValue.toFixed(0)} {getSymbol(defaultCurrency, lang)}
            </span>
          </div>
        </div>
        
        {/* Arrow */}
        <CaretRight size={20} className="text-[var(--text-muted)] flex-shrink-0" />
      </div>
    </motion.div>
  );
};
